
import React, { Component } from 'react';

import './../../../scss/App.scss';
import { trackingWrapper } from '../../utils/analytics';
import JWPlayer from './JWPlayer';

const NAMESPACE = '[ VideoOverlayJWPlayer ]';

class VideoOverlayJWPlayer extends Component {

	constructor(props){
		super(props);

		this.state = {
			videoId : null,
			tracked10Played: false,
			tracked50Played: false,
			tracked90Played: false
		}

		this.handleMediaStartedRef = this.handleMediaStarted.bind(this);
		this.handleMediaPlayingRef = this.handleMediaPlaying.bind(this);
		this.handleMediaEndedRef = this.handleMediaEnded.bind(this);
	}

	componentWillMount(){
		window.Howler.volume(0);

		this.setRandomVideo();

		// tracking
		// trackingWrapper('event', 'PPZgame-ad-play');
	}

	setRandomVideo(){

		//console.log("================ VideoOverlayJWPlayer :: setRandomVideo() - start pool:", videoAdsPool);

		let videoAdsPool = window.videoAdsPool;

		// get random from pool
		let video = videoAdsPool[Math.floor(Math.random() * videoAdsPool.length)];

		// remove chosen from pool
		const newVideoAdsPool = videoAdsPool.filter(x => x !== video);

		// if pool is empty, reset the pool with full list minus selected
		if(newVideoAdsPool.length === 0){
			videoAdsPool = [...window.data.config.videoAd.videos];

			// if total pool size is > 1, remove the selected so it does show back to back on next cycle
			if(window.data.config.videoAd.videos.length > 1){
				videoAdsPool = [...videoAdsPool.filter(x => x !== video)];
			}
		}
		else {
			videoAdsPool = [...newVideoAdsPool];
		}

		//console.log("VideoOverlayJWPlayer :: setRandomVideo() -  selected video: ", video);
		//console.log("VideoOverlayJWPlayer :: setRandomVideo() -  end pool: ", videoAdsPool);

		this.setState({
			videoId : video
		});
	}

	handleMediaStarted() {
		
		console.log( NAMESPACE, 'handleMediaStarted()' );
		
	}
	
	handleMediaPlaying( event ) {
		// console.log( NAMESPACE, 'media playing ', 'time: '+event.currentTime, ' duration: '+event.duration );
		const {tracked10Played, tracked50Played, tracked90Played} = this.state;
		const percentage = event.currentTime / event.duration;
		
		if( percentage > 0.9 && !tracked90Played ) {
			console.log( NAMESPACE, 'track 90% played' );
			trackingWrapper('event', 'PPZgame-ad-play-90%');
			this.setState({tracked90Played: true});
		} 

		if( percentage > 0.5 && !tracked50Played ) {
			console.log( NAMESPACE, 'track 50% played' );
			trackingWrapper('event', 'PPZgame-ad-play-50%');
			this.setState({tracked50Played: true});
		} 

		if( percentage > 0.1 && !tracked10Played ) {
			console.log( NAMESPACE, 'track 10% played' );
			trackingWrapper('event', 'PPZgame-ad-play-10%');
			this.setState({tracked10Played: true});
		}
	}
	
	handleMediaEnded() {
		console.log( NAMESPACE, 'handleMediaEnded()' );
		
		this.closeOverlay();
	}

	closeOverlay(){
		window.Howler.volume(1);
		
		this.props.handleVideoOverlayClose();
	}
	
	render(){
		const setup = {
			file: `https://content.uplynk.com/${this.state.videoId}.m3u8`,
			autostart: true
		}

		const onEvents = {
			complete: this.handleMediaEndedRef,
			time: this.handleMediaPlayingRef
		}

		return(
			<div id="videoOverlay">
				<div className="text">People Puzzler Game Will Resume After This Video</div>
				<div className="video-player">
					<div id="jwplayer" />
					<JWPlayer
						playerId='jwplayer'
						setup={setup}
						onEvents={onEvents}
					/>
				</div>
					<div className="closeBtn" onClick={() => this.closeOverlay()}>x</div>
			</div>
		);
	}
}

export default VideoOverlayJWPlayer;


// WEBPACK FOOTER //
// ./src/js/components/ads/VideoOverlayJWPlayer.js